module.exports = __webpack_public_path__ + "img/line-ux.463d6865.svg";